import React, { useState, useRef } from 'react'
import { Typography, Box, Divider, Button, Stack, ListItem, List, ListItemText, CardActionArea, CardActions, Grid, Card, CardContent, CardMedia } from "@mui/material"
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { useSelector } from 'react-redux';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useTranslation } from 'react-i18next';




export default function Views({ hostelData }) {

    const boxRef = useRef(null);

    const {t} = useTranslation()

    const language = useSelector((state) => state.language.language)
    console.log(language)

    const handleScrollLeft = () => {
        if (boxRef.current) {
          boxRef.current.scrollTo({
            left: boxRef.current.scrollLeft - 395, 
            behavior: 'smooth',
          });
        }
      };
    
      
      const handleScrollRight = () => {
        if (boxRef.current) {
          boxRef.current.scrollTo({
            left: boxRef.current.scrollLeft + 395,
            behavior: 'smooth',
          });
        }
      };

      const sliderSettings = {
        dots: false,
        infinite: false,
        autoplay : true, 
        speed: 1000,
        slidesToShow: 3.3, // adjust based on screen size or layout
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
            },
          },
          {
            breakpoint: 320,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      };

    return (
        <>
            <Box py={6} sx={{ background: "#EFFEFF" }}>

                <Box display="flex" flexDirection={{xs : 'column', lg : 'row'}} sx={{gap : 3}} justifyContent='space-around' alignItems='center'>
                    {/* <Box></Box> */}

                    <Box sx={{width : {xs : '42%',lg : '15%'}}}>
                    <Typography variant="h6_1" color="primary" border="1px solid #27BAC4" padding="10px 50px" borderRadius="50px" letterSpacing="1.1px" width="fit-content">{t("VIEWS")}</Typography>
                    </Box>

                    {/* <Box sx={{width : {xs : '100%', lg : '10%'}, display : 'flex', justifyContent : 'space-between', gap : 2, px : {xs : 3, lg : 0}}}>
                    <Button onClick={handleScrollLeft} ><ChevronLeftIcon sx={{fontSize : '24px'}}/></Button>
                    <Button onClick={handleScrollRight}><ChevronRightIcon /></Button>
                    </Box> */}
                
                </Box>
                
                <Box sx={{px : {xs : 1, lg : 5},  py : 10}}>
                <Slider {...sliderSettings}>
  {hostelData?.Views?.map((item, index) => (
    <Box key={index} sx={{px : {xs : 2, xl : 0}}}>
      <Card
        sx={{
          minWidth: {xs : '100%', lg : 353},
          maxWidth: {xs : 250, lg : 363},
          height: '100%',
          borderRadius: '20px',
          textAlign: 'start',
          position: 'relative',
          boxShadow: '1px 120px 28px -7px rgba(0,0,0,0.08)',
        }}
      >
        <Typography
          variant="h6_3"
          sx={{
            position: 'absolute',
            color: '#FFFFFF',
            zIndex: 1,
            bottom: 20,
            left: 30,
          }}
        >
          {item?.title[language]}
        </Typography>
        <CardActionArea>
          <Box sx={{ position: 'relative', width: '100%', height: '400px' }}>
            <CardMedia
              component="img"
              image={process.env.REACT_APP_FILE_PATH + item?.img}
              alt="view image"
              sx={{
                borderRadius: '20px',
                height: '400px',
                objectFit: 'cover',
              }}
            />
            <Box
              sx={{
                position: 'absolute',
                bottom: 0,
                left: 0,
                right: 0,
                height: '20%',
                background: 'linear-gradient(transparent, rgba(0, 0, 0, 0.8))',
                borderRadius: '10px',
              }}
            />
          </Box>
        </CardActionArea>
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            height: '100%',
            width: '100%',
            background: 'linear-gradient(to top, rgba(0,0,0,.3), rgba(0,0,0,0))',
          }}
        />
      </Card>
    </Box>
  ))}
</Slider>
</Box>
            </Box>
        </>
    )
}
